import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  return <section id="offer" className="py-24 px-4 md:px-8 bg-nightBlue relative" data-id="element-101">
      <div className="max-w-4xl mx-auto text-center" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-103">
          <h2 className="font-playfair font-bold text-3xl md:text-4xl text-warmWhite mb-12 max-w-2xl mx-auto leading-tight" data-id="element-104">
            Recuperar tu salud, tu memoria y tu buen humor no debería costar una
            fortuna.
          </h2>

          <div className="bg-nightBlueLighter border border-gold/30 rounded-3xl p-8 md:p-12 max-w-2xl mx-auto shadow-2xl relative overflow-hidden" data-id="element-105">
            {/* Subtle glow */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-gold/5 blur-[80px] pointer-events-none" data-id="element-106" />

            <div className="relative z-10" data-id="element-107">
              <p className="font-lato text-lg text-warmWhite/70 mb-4" data-id="element-108">
                El Sistema Completo de Sincronización Biológica tiene un valor
                regular de
              </p>
              <div className="text-2xl md:text-3xl font-montserrat text-silver line-through decoration-red-500/50 mb-8" data-id="element-109">
                $29.00 USD
              </div>

              <p className="font-montserrat font-semibold text-gold text-xl mb-2" data-id="element-110">
                Tu inversión hoy:
              </p>
              <div className="text-6xl md:text-7xl font-playfair font-bold text-gold mb-6 drop-shadow-[0_0_15px_rgba(201,168,76,0.3)]" data-id="element-111">
                Solo $6.39 <span className="text-3xl" data-id="element-112">USD</span>
              </div>

              <p className="font-lato text-lg text-warmWhite/90 mb-10" data-id="element-113">
                Un único pago para recuperar el resto de tus noches.
              </p>

              <CTAButton href="https://codexvital.com/cart/45360389783596:1" className="w-full md:w-auto" data-id="element-114">
                SÍ, QUIERO VOLVER A DORMIR PROFUNDAMENTE
              </CTAButton>
              <p className="font-lato text-sm text-warmWhite/60 mt-6" data-id="element-115">
                Haz clic aquí para descargar el protocolo y empezar tu
                transformación esta noche.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}